lmApp.controller('GeoIPRulesController', ['$routeParams', '$location', '$q', '$scope', '$interval', '$rootScope', '$templateCache', '$compile', '$filter', 'ModalWindowService', 'ValidatorService', 'ToastService', 'GeoIPRules', 'GroupResource', 'ManagerResource', 'TimezoneService', 'CountriesService',
  function ($routeParams, $location, $q, $scope, $interval, $rootScope, $templateCache, $compile, $filter, ModalWindowService, ValidatorService, ToastService, GeoIPRules, GroupResource, ManagerResource, TimezoneService, CountriesService) {
    $scope.loading = false;
    $scope.rules = [];
    $scope.orderBy = 'priority';

    $scope.newRule = {};
    $scope.newRuleValidateErrors = {};

    var _newRule = {
      name: '',
      policy: 'allow',
      type: 'all',
      subnet: '',
      singleIP: '',
      country: {}
    };
    $scope.countries = _.sortBy(angular.copy(CountriesService.Countries), 'title');
    var groupCache = {}; // key: group ID, value: group name

    // Timezone
    var timezone = _.find(TimezoneService.Timezones, {title: 'UTC'});
    $scope.tz = timezone.title;
    ManagerResource.get().$promise
      .then(function (result) {
        if (result.length !== 0) {
          var manager = _.find(result, {username: $rootScope.globals.currentUser.username});
          if (manager) {
            timezone = _.find(TimezoneService.Timezones, {title: manager.ui_timezone || 'UTC'});
            $scope.tz = timezone.title;
          }
        }
      })
      .catch(function (reason) {
        $rootScope.debugInfo(reason, 'silent');
      });

    $scope.convertTime = function (dt) {
      return TimezoneService.addTimezoneToDate(dt, timezone)
    };

    //
    function processRules(rules) {
      for (var i=0; i < rules.length; i++) {
        if (rules[i].subject_type === 'country' ) {
          rules[i]._country = _.find($scope.countries, {code: rules[i].subject}) || {};
        }
        if (rules[i].subject_type === 'group' ) {
          rules[i]._group = groupCache[rules[i].subject];
        }
        rules[i]._description = ruleDescription(rules[i]);
      }
      $scope.rules = _.sortBy(rules, 'priority');
      $scope.loading = false;
      $rootScope.hideLinearProgress('#geoIPRulesLoader');
    }

    $scope.getRules = function() {
      $scope.loading = true;
      $rootScope.showLinearProgress('#geoIPRulesLoader');

      return GeoIPRules.get().$promise
        .then(function (rules) {
          if (rules.length === 0) {
            $scope.rules = [];
            $scope.loading = false;
            $rootScope.hideLinearProgress('#geoIPRulesLoader');
            return;
          }
          var groupIDs = [];
          for (var i = 0; i < rules.length; i++) {
            if (rules[i].subject_type === 'group' && !groupCache.hasOwnProperty(rules[i].subject)) {
              groupIDs.push(rules[i].subject);
            }
          }
          if (groupIDs.length > 0) {
            GroupResource.get({'id[in]': groupIDs.join(',')}).$promise
                .then(function (groups) {
                  for (var i = 0; i < groups.length; i++) {
                    groupCache[groups[i].id] = groups[i].name || groups[i].ext_id;
                  }
                  processRules(rules);
                })
                .catch(function (reason) {
                  processRules(rules);
                  $rootScope.debugInfo(reason);
                });
          } else {
            processRules(rules);
            return;
          }
        })
        .catch(function (reason) {
          $scope.loading = false;
          $rootScope.hideLinearProgress('#geoIPRulesLoader');
          $rootScope.debugInfo(reason);
        });
    };

    $scope.changeOrder = function (field) {
      $scope.orderBy = $scope.orderBy.startsWith('-') ? 'priority' : '-priority';
    };

    $scope.createNewRule = function() {
      if ($scope.loading) return;
      $rootScope.showLinearProgress('#geoIPRulesLoader');
      $scope.newRule = angular.copy(_newRule);
      $scope.newRuleValidateErrors = {};
      $scope.newRuleList = angular.copy($scope.rules);

      var inner = $templateCache.get('new-geoip-rule.tpl.html');
      inner = $compile(inner)($scope);

      $scope.window = ModalWindowService.Open({
        content: inner,
        isFixed: true,
        clear: true,
        keyboard: true,
        actions: [
          {
            title: 'Create',
            color: 'green',
            check: function () {
              return isNewRuleValid();
            },
            fn: function () {
              $scope.saveNewRule();
            }
          },
          {
            title: 'Cancel',
            color: 'red',
            fn: function () {
              $rootScope.hideLinearProgress('#geoIPRulesLoader');
            }
          }
        ],
        size: {
          s: 11,
          l: 8
        }
      });
    };

    function isNewRuleValid() {
      var valid = true;
      $scope.newRuleValidateErrors = {};
      if (!_.trim($scope.newRule.name)) {
        $scope.newRuleValidateErrors.name = true;
        valid = false;
      }
      if ($scope.newRule.type === 'network') {
        if (!_.trim($scope.newRule.subnet)) {
          $scope.newRuleValidateErrors.subnet = true;
          $scope.newRuleValidateErrors.subnetText = 'Required field';
          valid = false;
        } else if (!ValidatorService.IPWithMask($scope.newRule.subnet)) {
          $scope.newRuleValidateErrors.subnet = true;
          $scope.newRuleValidateErrors.subnetText = 'Invalid subnet';
          valid = false;
        }
      }
      if ($scope.newRule.type === 'single_ip') {
        if (!_.trim($scope.newRule.singleIP)) {
          $scope.newRuleValidateErrors.singleIP = true;
          $scope.newRuleValidateErrors.singleIPText = 'Required field';
          valid = false;
        } else if (!ValidatorService.IP($scope.newRule.singleIP)) {
          $scope.newRuleValidateErrors.singleIP = true;
          $scope.newRuleValidateErrors.singleIPText = 'Invalid IP';
          valid = false;
        }
      }
      if ($scope.newRule.type === 'country' && !$scope.newRule.country.code) {
        $scope.newRuleValidateErrors.country = true;
        valid = false;
      }
      return valid;
    }

    $scope.saveNewRule = function() {
      $scope.loading = true;
      $rootScope.showLinearProgress('#geoIPRulesLoader');

      var newRule = {};
      var updatedRules = [];
      for (var i=0; i < $scope.newRuleList.length; i++) {
        var rule = $scope.newRuleList[i];
        if (rule.id === 'new') {
          newRule = {
            name: rule.name,
            priority: i+1,
            allow:  rule.allow,
            subject_type: rule.subject_type,
            subject: rule.subject
          };
          continue
        }
        if (rule.priority !== (i+1)) {
          rule.priority = i+1;
          updatedRules.push(rule);
        }
      }

      GeoIPRules.create(newRule).$promise
        .then(function () {
            if (updatedRules.length) {
              var reqList = [];
              for(var i=0; i < updatedRules.length; i++) {
                reqList.push(GeoIPRules.update(updatedRules[i]).$promise)
              }
              $q.all(reqList)
                  .then(function(values) {
                    $scope.getRules();
                    ToastService.Small({
                      title: 'The new GeoIP rule has been added',
                      color: 'green',
                      icon: 'check'
                    });
                    $scope.loading = false;
                    $rootScope.hideLinearProgress('#geoIPRulesLoader');
                  })
                  .catch(function(reason) {
                    $scope.loading = false;
                    $rootScope.hideLinearProgress('#geoIPRulesLoader');
                    $rootScope.debugInfo(reason);
                    ToastService.Small({
                      title: 'Failed to add new GeoIP rule',
                      color: 'red',
                      icon: 'server-minus'
                    });
                  });
            } else {
              $scope.getRules();
              ToastService.Small({
                title: 'The new GeoIP rule has been added',
                color: 'green',
                icon: 'check'
              });
              $scope.loading = false;
              $rootScope.hideLinearProgress('#geoIPRulesLoader');
            }
            return;
          })
          .catch(function (reason) {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#geoIPRulesLoader');
            $rootScope.debugInfo(reason);
            ToastService.Small({
              title: 'Failed to add new GeoIP rule',
              color: 'red',
              icon: 'server-minus'
            });
          });
    };

    function normRuleToJsonAPI(rule) {
      var r = {
        allow: rule.policy === 'allow',
        name: _.trim(rule.name),
        subject_type: '',
        subject: '',
        _country: {}
      };
      switch (rule.type) {
        case 'all':
          r.subject_type = 'everyone';
          break;
        case 'network':
          r.subject_type = 'network';
          r.subject = _.trim(rule.subnet);
          break;
        case 'single_ip':
          r.subject_type = 'network';
          r.subject = _.trim(rule.singleIP)+'/32';
          break;
        case 'country':
          r.subject_type = 'country';
          r.subject = rule.country.code;
          r._country = rule.country;
      }
      return r;
    }

    function ruleDescription(rule) {
      var description = rule.allow ? 'allow ' : 'deny ';
      if (rule.subject_type === 'everyone') {
        return description + 'all';
      }
      if (rule.subject_type === 'network' && !rule.subject.endsWith('/32')) {
        if (rule.subject) {
          return description + 'subnet ' + rule.subject;
        }
        return description + 'subnet...';
      }
      if (rule.subject_type === 'network' && rule.subject.endsWith('/32')) {
        if (rule.subject !== '/32') {
          return description + 'IP ' + rule.subject.substring(0, rule.subject.length - 3);
        }
        return description + 'IP...';
      }
      if (rule.subject_type === 'country') {
        if (rule._country.title) {
          return description + 'country ' + rule._country.title + ' (' + rule._country.code + ')';
        }
        return description + 'country...';
      }
      if (rule.subject_type === 'group') {
        var groupName = rule._group || rule.subject;
        return description + 'user group "' + groupName + '"';
      }
      return '';
    }

    $scope.$watch('newRule', function(newVal, oldVal){
      if (_.isEqual(newVal, oldVal)) {
        return;
      }
      var newItem = $filter('filter')($scope.newRuleList, {'id': 'new'});
      if (!newItem.length) {
        $scope.newRuleList.splice(0, 0, {
          id: 'new',
          allow: true,
          subject_type: 'everyone',
          name: '',
          _description: ''
        });
      } else {
        var rule = normRuleToJsonAPI(newVal);
        newItem[0].allow = rule.allow;
        newItem[0].name = rule.name;
        newItem[0].subject_type = rule.subject_type;
        newItem[0].subject = rule.subject;
        newItem[0]._description = ruleDescription(rule);
        if (rule._country.code) {
          $scope.newRuleValidateErrors.country = false;
        }
      }
    }, true);

    $scope.deleteRule = function (rule) {
      if ($scope.loading) return;
      $rootScope.showLinearProgress('#geoIPRulesLoader');

      $scope.modalWindowScope = $scope.$new();
      var inner = '<span class="heavy">Are you sure you want <b>to delete</b> the geoIP rule "' + rule.name +'"?</span>';

      ModalWindowService.Open({
        content: inner,
        actions: [
          {
            title: 'I understand. Do it',
            color: 'green',
            fn: function () {
              $scope.loading = true;
              GeoIPRules.remove({id: rule.id}).$promise
                .then(function () {
                  ToastService.Small({
                    title: 'The geoIP rule <b class="tc-white"> ' + rule.name + '</b> has been successfully deleted',
                    color: 'green',
                    icon: 'delete'
                  }, 1000 * 3);
                  $scope.getRules();
                  $scope.loading = false;
                  $rootScope.hideLinearProgress('#geoIPRulesLoader');
                })
                .catch(function (reason) {
                  $rootScope.hideLinearProgress('#geoIPRulesLoader');
                  $rootScope.debugInfo(reason);
                  ToastService.Small({
                    title: 'Failed to remove geoIP rule',
                    color: 'red',
                    icon: 'delete'
                  });
                });
            }
          },
          {
            title: 'cancel',
            color: 'red',
            fn: function () {
              $rootScope.hideLinearProgress('#geoIPRulesLoader');
            }
          }
        ],
        onComplete: function () {
          $scope.modalWindowScope.$destroy();
        }
      });
    };

    $scope.reorderRules = function() {
      if ($scope.loading) return;
      $rootScope.showLinearProgress('#geoIPRulesLoader');
      $scope.reorderedList = angular.copy($scope.rules);

      var inner = $templateCache.get('reorder-geoip-rules.tpl.html');
      inner = $compile(inner)($scope);

      $scope.window = ModalWindowService.Open({
        content: inner,
        isFixed: true,
        clear: true,
        keyboard: true,
        actions: [
          {
            title: 'Update',
            color: 'green',
            fn: function () {
              $scope.loading = true;
              var updatedRules = [];
              for (var i=0; i < $scope.reorderedList.length; i++) {
                var rule = $scope.reorderedList[i];
                if (rule.priority !== (i+1)) {
                  rule.priority = i+1;
                  updatedRules.push(rule);
                }
              }
              if (updatedRules.length) {
                var reqList = [];
                for(var i=0; i < updatedRules.length; i++) {
                  reqList.push(GeoIPRules.update(updatedRules[i]).$promise)
                }
                $q.all(reqList)
                    .then(function(values) {
                      $scope.getRules();
                      ToastService.Small({
                        title: 'The geoIP rules have been reordered',
                        color: 'green',
                        icon: 'check'
                      });
                      $scope.loading = false;
                      $rootScope.hideLinearProgress('#geoIPRulesLoader');
                    })
                    .catch(function(reason) {
                      $scope.loading = false;
                      $rootScope.hideLinearProgress('#geoIPRulesLoader');
                      $rootScope.debugInfo(reason);
                      ToastService.Small({
                        title: 'Failed to reorder geoIP rules',
                        color: 'red',
                        icon: 'server-minus'
                      });
                    });
              } else {
                $scope.loading = false;
                $rootScope.hideLinearProgress('#geoIPRulesLoader');
              }
            }
          },
          {
            title: 'Cancel',
            color: 'red',
            fn: function () {
              $rootScope.hideLinearProgress('#geoIPRulesLoader');
            }
          }
        ],
        size: {
          s: 11,
          l: 8
        }
      });
    };

    $scope.getRules();
  }]);
